import { render, staticRenderFns } from "./WallDonationBlock.vue?vue&type=template&id=31db5754"
import script from "./WallDonationBlock.vue?vue&type=script&lang=js"
export * from "./WallDonationBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports